package com.zq.webproject.model

import kotlinx.serialization.Serializable

@Serializable
data class ProductDetail(
    val id: Int,
    val name: String,
    val price: Double,
    val category: String,
    val imageUrl: String,
    val sales: Int,
    val views: Int,
    val description: String,
    val status: Int,
    val createdAt: String, // 接口返回的时间字符串
    val updatedAt: String,
    val image1: String? = null, // 详情图1，可能为null
    val image2: String? = null,  // 详情图2，可能为null
    val image3: String? = null,  // 详情图3，可能为null
    val baiduUrl: String? = null,      // 百度网盘链接
    val extractCode: String? = null,   // 提取码
    val otherResources: List<Resource>? = null  // 其他资源列表
)

@Serializable
data class ProductDetailResponse(
    val code: Int,
    val message: String,
    val data: ProductDetail?
)